import axios from '../../../axios/index.js';
import store from '../../../../store/store.js';
import Constant from '../../../../../constant';
import api from '../../../api/api.js';

// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter((callback) => callback(access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

export default {
  // init() {
  //   axios.interceptors.response.use(
  //     function (response) {
  //       return response;
  //     },
  //     function (error) {
  //       // const { config, response: { status } } = error
  //       const { config, response } = error;
  //       const originalRequest = config;
  //       // if (status === 401) {
  //       if (response && response.status === 401) {
  //         if (!isAlreadyFetchingAccessToken) {
  //           isAlreadyFetchingAccessToken = true;
  //           store.dispatch('auth/v2fetchAccessToken').then((access_token) => {
  //             isAlreadyFetchingAccessToken = false;
  //             onAccessTokenFetched(access_token);
  //           });
  //         }

  //         const retryOriginalRequest = new Promise((resolve) => {
  //           addSubscriber((access_token) => {
  //             originalRequest.headers.Authorization = `Bearer ${access_token}`;
  //             resolve(axios(originalRequest));
  //           });
  //         });
  //         return retryOriginalRequest;
  //       }
  //       return Promise.reject(error);
  //     }
  //   );
  // },
  login(password, email, challenge) {
    var data = JSON.stringify({
      email: email,
      password: password,
    });

    var config = {
      method: 'post',
      // url: `https://cors-anywhere.herokuapp.com/https://openid.vwtv.pt/api/login/?login_type=web1&login_challenge=${challenge}`, //uncomment when use in local
      url: `${Constant.hydra_ep}/api/login/?login_type=web1&login_challenge=${challenge}`, // comment when use in local
      headers: {
        'Content-Type': 'application/json',
      },
      data: data,
    };
    return api(config);
  },
  registerUser(firstName, lastName, email, pwd) {
    // const url='https://cors-anywhere.herokuapp.com/' + Constant.hydra_ep + '/api/user/register/'
    const url = Constant.hydra_ep + '/api/user/register/';
    return api.post(url, {
      firstName: firstName,
      lastName: lastName,
      username: firstName + lastName,
      email,
      password: pwd,
      profile: {
        zip: 'your_zip_code',
        city: 'your_city_name',
        active: true,
      },
    });
  },
  updateUser(payload) {
    var form = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      form.append(key, value);
    }
    return api.patch(Constant.profilingUrl + `/api/profile/update/`, form);
  },
  changePassword(payload) {
    return api.post(`${Constant.hydra_ep}/api/change_password/`, payload);
  },
  refreshToken() {
    return api.post(Constant.apiUrl + '/api/auth/refresh-token/', {
      accessToken: localStorage.getItem('accessToken'),
    });
  },
  generateNonce(payload) {
    var FormData = require('form-data');
    var data = new FormData();
    data.append('public_add', payload.public_add);

    var config = {
      method: 'post',
      // url: `https://cors-anywhere.herokuapp.com/${Constant.hydra_ep}/api/user/metamask/register/`, //uncomment when use in local
      url: `${Constant.hydra_ep}/api/user/metamask/register/`, // comment when use in local
      data: data,
    };

    return api(config);
  },
  verifySignature(payload) {
    console.log(payload);
    var config = {
      method: 'post',
      // url: `https://cors-anywhere.herokuapp.com/${Constant.hydra_ep}/api/login/?login_challenge=${payload.login_challenge}&login_type=web3`, //uncomment when use in local
      url: `${Constant.hydra_ep}/api/login/?login_challenge=${payload.login_challenge}&login_type=web3`, // comment when use in local
      headers: {
        'Content-Type': 'application/json',
      },
      data: payload,
    };

    return api(config);
  },
  sendOtp(payload) {
    return api.get(Constant.apiCastUrl + '/api/event/send/otp/', {
      params: { email: payload.email, cast_id: payload.cast_id },
    });
  },
  verifyOtp(payload) {
    return api.get(Constant.apiCastUrl + '/api/event/validate/otp/', {
      params: {
        email: payload.email,
        otp: payload.otp,
        cast_id: payload.cast_id,
      },
    });
  },
  saveAddress(payload) {
    return api.post(
      Constant.apiCastUrl + `/api/event/add/wallet/address/`,
      payload
    );
  },
  eventDetail(payload) {
    return api.get(Constant.apiCastUrl + '/api/event/meeting/info/', {
      params: {
        public_meeting_id: payload,
      },
    });
  },
  async submitSheet(payload) {
    console.log(payload);
    return api.post(
      Constant.apiCastUrl + '/api/event/invitee/import/',
      payload
    );
  },
  generateAccessToken(payload) {
    console.log('payload', payload);
    var data = JSON.stringify({
      access_token: payload.access_token,
    });
    return api({
      method: 'POST',
      // url: `https://cors-anywhere.herokuapp.com/${Constant.hydra_ep}/api/login/?login_type=web2&login_challenge=${payload.login_challenge}`, //uncomment when use in local
      url: `${Constant.hydra_ep}/api/login/?login_type=web2&login_challenge=${payload.login_challenge}`, // comment when use in local
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
  sendResetEmail(payload) {
    return api.get(
      Constant.hydra_ep +
      `/api/password/reset/mail/?email=${payload}&origin=cast`
    );
  },
  resetPassword(payload) {
    return api.post(Constant.hydra_ep + '/api/password/reset/', payload);
  },
  autoLogin({ username, lc, token }) {
    return api.get(
      Constant.hydra_ep +
      `/api/auto/login/?username=${username}&login_challenge=${lc}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
  contactUs(payload) {
    return api.post(Constant.apiUrl + '/community/contact_us/', payload);
  },

  //v2auth-apis
  v2get2FaActivationKey() {
    const url = Constant.authApiBaseUrl + '/api/v1/auth/2fa/key/';
    return api.get(url);
  },
  v2enable2fa(key, code) {
    const url = Constant.authApiBaseUrl + '/api/v1/auth/2fa/activate/';
    return api.post(url, {
      key,
      code,
    });
  },
  v2disable2fa(code) {
    const url = Constant.authApiBaseUrl + '/api/v1/auth/2fa/deactivate/';
    return api.post(url, {
      code,
    });
  },
  v2registerUser(firstName, lastName, email, password) {
    const url = Constant.authApiBaseUrl + '/api/v1/auth/email/register/';
    return api.post(url, {
      firstName,
      lastName,
      email,
      password,
    });
  },
  v2loginUser(email, password) {
    const url = Constant.authApiBaseUrl + '/api/v1/auth/email/login/';
    return api.post(url, {
      email,
      password,
    });
  },
  v2logOut() {
    const token = localStorage.getItem("accessToken");
    const url = Constant.authApiBaseUrl + "/api/v1/auth/logout"
    return api.post(url, {}, // No body needed
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  v2generateNonce(address) {
    const url = Constant.authApiBaseUrl + '/api/v1/auth/wallet/nonce/';
    return api.post(url, {
      address
    });
  },
  v2verifySignature(token, signature) {
    const url = Constant.authApiBaseUrl + '/api/v1/auth/wallet/login/';
    return api.post(url, {
      token,
      signature,
    });
  },
  v2verifyConnect(token, signature) {
    const url = Constant.authApiBaseUrl + '/api/v1/auth/wallet/connect/';
    return api.post(url, {
      token,
      signature,
    });
  },
};
